/* stopColor definitions need to be constant across light and dark themes */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React, { PureComponent } from 'react';

import { chunk } from 'lodash-es';

import { CommitGraphElement } from 'src/utils/commit-graph-builder';

import Chunk from './chunk';
import * as styles from './commit-graph.styled';

export type GraphProps = {
  chunkSize: number;
  colWidth: number;
  focusedHash: string;
  graph: CommitGraphElement[];
  hasPadding: boolean;
  offsetX: number;
  offsetY: number;
  onNodeClick: (id: string) => void;
  sliceHeight: number;
  width: number;
  height: number;
};

export default class Graph extends PureComponent<GraphProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    hasPadding: false,
  };

  renderDefs() {
    return (
      <defs>
        <linearGradient id="opacityGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0" stopColor="#000" />
          <stop offset="1%" stopColor="#000" />
          <stop offset="5%" stopColor="#fff" />
          <stop offset="97%" stopColor="#fff" />
          <stop offset="99%" stopColor="#000" />
        </linearGradient>
        <mask id="opacityGradientMask">
          <rect
            fill="url(#opacityGradient)"
            width="100%"
            height="100%"
            x="0"
            y="0"
          />
        </mask>
      </defs>
    );
  }

  // @ts-ignore TODO: fix noImplicitAny error here
  renderChunk = (element, index) => {
    const {
      chunkSize,
      colWidth,
      focusedHash,
      onNodeClick,
      offsetX,
      offsetY,
      sliceHeight,
      hasPadding,
    } = this.props;
    const top = offsetY + index * chunkSize * sliceHeight;

    return (
      <Chunk
        chunk={element}
        colWidth={colWidth}
        focusedHash={focusedHash}
        key={`chunk-${element[0].hash}`}
        left={offsetX}
        onNodeClick={onNodeClick}
        sliceHeight={sliceHeight}
        hasPadding={hasPadding}
        top={top}
      />
    );
  };

  render() {
    const { chunkSize, graph, width, height } = this.props;

    return (
      <styles.Graph width={width} height={height} focusable="false" aria-hidden>
        {this.renderDefs()}
        <g mask="url(#opacityGradientMask)">
          {chunk(graph, chunkSize).map(this.renderChunk)}
        </g>
      </styles.Graph>
    );
  }
}
